import { render, staticRenderFns } from "./ConfettiExplosion.vue?vue&type=template&id=445328e0&"
import script from "./ConfettiExplosion.vue?vue&type=script&lang=js&"
export * from "./ConfettiExplosion.vue?vue&type=script&lang=js&"
import style0 from "./ConfettiExplosion.vue?vue&type=style&index=0&id=445328e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports